import { hc, parseResponse } from "hono/client";
//#region src/client.ts
const DEFAULT_BASE_URL = "http://localhost:3000";
const PROD_BASE_URL = "https://assets-api.locuslabs.com/prod";
const createAssetsClient = ({ token, baseUrl = DEFAULT_BASE_URL, fetcher = fetch } = {}) => hc(baseUrl, {
	headers: { ...token ? { "x-api-key": token } : {} },
	fetch: fetcher
});
function createAssetsHelper(opts) {
	const fetcher = opts.fetcher ?? fetch;
	const client = createAssetsClient({
		...opts,
		baseUrl: opts.baseUrl ?? PROD_BASE_URL,
		fetcher
	});
	return {
		client,
		listVenues: async (options) => {
			return parseResponse(client.venues.$get({ query: { full: options?.full ? "true" : void 0 } }));
		},
		describeVenue: async (venue) => {
			return parseResponse(client.venues[":venue"].$get({ param: { venue } }));
		},
		createVenue: async (venue, body) => {
			return parseResponse(client.venues[":venue"].$post({
				param: { venue },
				json: body
			}));
		},
		removeVenue: async (venue) => {
			return parseResponse(client.venues[":venue"].$delete({ param: { venue } }));
		},
		createAccount: async (body) => {
			return parseResponse(client.accounts.$post({ json: body }));
		},
		listAccounts: async (assetStage) => {
			return parseResponse(client.accounts.stage[":assetStage"].$get({ param: { assetStage } }));
		},
		describeAccount: async (account) => {
			return parseResponse(client.describe.accounts[":account"].$get({ param: { account } }));
		},
		getApiKeys: async (account) => {
			return parseResponse(client.keys.accounts[":account"].$get({ param: { account } }));
		},
		listAccountsForVenue: async (assetStage, venue) => {
			return parseResponse(client.accounts.stage[":assetStage"].venue[":venue"].$get({ param: {
				assetStage,
				venue
			} }));
		},
		addVenueToAccount: async (account, venue, options) => {
			return parseResponse(client.add.accounts[":account"].venue[":venue"].$post({
				param: {
					account,
					venue
				},
				query: { email: options?.email ? "true" : void 0 }
			}));
		},
		removeVenueFromAccount: async (account, venue, options) => {
			return parseResponse(client.remove.accounts[":account"].venue[":venue"].$post({
				param: {
					account,
					venue
				},
				query: { email: options?.email ? "true" : void 0 }
			}));
		},
		getVenueLists: async (account, assetStage) => {
			return parseResponse(client["venue-lists"].accounts[":account"].stage[":assetStage"].$get({ param: {
				account,
				assetStage
			} }));
		},
		updateVenueLists: async (account, assetStage) => {
			return parseResponse(client["venue-lists"].accounts[":account"].stage[":assetStage"].$post({ param: {
				account,
				assetStage
			} }));
		},
		verifyVenueList: async (account, assetStage, venue) => {
			return parseResponse(client.verify[":account"].stage[":assetStage"].venue[":venue"].$get({ param: {
				account,
				assetStage,
				venue
			} }));
		},
		getVenueHistory: async (account, assetStage, venue, options) => {
			return parseResponse(client.accounts[":account"].stage[":assetStage"].venue[":venue"].$get({
				param: {
					account,
					assetStage,
					venue
				},
				query: {
					format: options?.format,
					limit: options?.limit
				}
			}));
		},
		getRemovedVenues: async (account, assetStage) => {
			return parseResponse(client.removed.accounts[":account"].stage[":assetStage"].venue.$get({ param: {
				account,
				assetStage
			} }));
		},
		getFilenames: async (account, assetStage, venue, format, options) => {
			return parseResponse(client.files.accounts[":account"].stage[":assetStage"].venue[":venue"].format[":format"].$get({
				param: {
					account,
					assetStage,
					venue,
					format
				},
				query: { version: options?.version }
			}));
		},
		deployVenue: async (stage, venue, options) => {
			return parseResponse(client.deploy.stage[":stage"].venue[":venue"].$post({
				param: {
					stage,
					venue
				},
				query: { email: options?.email ? "true" : void 0 }
			}));
		},
		deployVenueAsync: async (stage, venue, options) => {
			return parseResponse(client.deploy.async.stage[":stage"].venue[":venue"].$post({
				param: {
					stage,
					venue
				},
				query: {
					email: options?.email ? "true" : void 0,
					dryRun: options?.dryRun ? "true" : void 0
				}
			}));
		},
		getDeployStatus: async (deployId) => {
			return parseResponse(client.deploy.status[":deployId"].$get({ param: { deployId } }));
		},
		deployVenueForAccount: async (stage, venue, account, options) => {
			return parseResponse(client.deploy.stage[":stage"].venue[":venue"].account[":account"].$post({
				param: {
					stage,
					venue,
					account
				},
				query: { invalidate: options?.invalidate ? "true" : void 0 }
			}));
		},
		process: async (venue, options) => {
			return parseResponse(client.process.venue[":venue"].$post({
				param: { venue },
				query: {
					executionStage: options?.executionStage,
					test: options?.test ? "true" : void 0,
					v5ToPixi: options?.v5ToPixi ? "true" : void 0,
					diff: options?.diff ? "true" : void 0,
					force: options?.force ? "true" : void 0
				}
			}));
		},
		publish: async (venue, options) => {
			return parseResponse(client.publish.venue[":venue"].$post({
				param: { venue },
				query: { executionStage: options?.executionStage }
			}));
		},
		getStatus: async (venue, options) => {
			return parseResponse(client.status.venue[":venue"].$get({
				param: { venue },
				query: { statusFilter: options?.statusFilter }
			}));
		},
		listStatuses: async (options) => {
			return parseResponse(client.status.$get({ query: {
				paginationToken: options?.paginationToken,
				statusFilter: options?.statusFilter
			} }));
		},
		getExecutionValidations: async (execution) => {
			return parseResponse(client.status.execution[":execution"].$get({ param: { execution } }));
		},
		listInvalidations: async (options) => {
			return parseResponse(client.invalidations.$get({ query: { limit: options?.limit } }));
		}
	};
}
//#endregion
export { createAssetsClient, createAssetsHelper };

//# sourceMappingURL=client.mjs.map